module.exports = __webpack_public_path__ + "static/media/airplane.8b8201d8.svg";